export var configAdapter = function (config) {
    var adapterConfig = {};
    config.items.forEach(function (current) {
        adapterConfig[current.key] = current.value;
    });
    return adapterConfig;
};
